export default () => {
  const color = "#36CFC9";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="108"
      height="107"
      viewBox="0 0 108 107"
      fill="none"
    >
      <g clipPath="url(#clip0_6657_5024)">
        <path
          d="M54 106.835C83.4552 106.835 107.333 82.9565 107.333 53.5013C107.333 24.0461 83.4552 0.167969 54 0.167969C24.5448 0.167969 0.666626 24.0461 0.666626 53.5013C0.666626 82.9565 24.5448 106.835 54 106.835Z"
          fill={color}
        />
        <path
          d="M49.7191 69.5C48.3067 69.5 46.8946 68.938 45.8165 67.814L34.443 55.9561C32.2868 53.7091 31.9842 50.4139 34.1404 48.1667C36.2966 45.9186 39.8716 45.9186 42.0278 48.1667L49.7191 57.7241L65.9053 39.186C68.0615 36.938 71.898 36.938 74.0542 39.186C76.2104 41.433 75.4308 45.0766 73.2746 47.3237L53.6217 67.814C52.5438 68.938 51.1314 69.5 49.7191 69.5Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_6657_5024">
          <rect
            width="106.667"
            height="106.667"
            fill="white"
            transform="translate(0.666626 0.167969)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
